import { useQuery } from '@tanstack/react-query';
import { useTableRequest } from '@dfl/mui-admin-layout';
import { CurrencySettingsService } from 'modules/sales/settings/payment-settings/services';
// Del fichero concreto y NO del barril `constants`: el barril reexporta
// `payment-settings.filters`, que importa el barril `modules/common/constants`
// -> `common.columns` -> `CellType`. Un hook de moneda acababa arrastrando las
// definiciones de columnas de tabla de medio admin, y en tests eso revienta la
// suite al cargar el modulo.
import { CURRENCY_KEY } from 'modules/sales/settings/payment-settings/constants/payment-settings-enum';
import { useUser } from '@dfl/react-security';

export const useFindCurrency = () => {
  const { user } = useUser();
  const { fetch, queryKey } = useTableRequest(CurrencySettingsService.getCurrency);

  return useQuery({ queryKey: [CURRENCY_KEY, queryKey], queryFn: fetch, enabled: !!user });
};
